import { CreateCategorieEventRequest, DeleteCategorieEventRequest, GetCategoriesEventRequest, ImportFileEventCategoriesRequest, UpdateCategorieEventRequest } from '@aoe/client';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CategoryResponse, CreateCategoryResponse, DeleteCategoryResponse, ImportCategoriesResponse, UpdateCategoryResponse } from 'src/app/core/interfaces/CategoryResponse.interface';


export const categoriesActions = createActionGroup({
  source: 'Categories',
  events: {
    'Load categories event': props<{ payload: GetCategoriesEventRequest, eventId: string }>(),
    'Load categories event success': props<CategoryResponse>(),
    'Load categories event failed': props<CategoryResponse>(),

    'Create catetogy event': props<{ payload: CreateCategorieEventRequest, eventId: string }>(),
    'Create catetogy event success': props<CreateCategoryResponse>(),
    'Create catetogy event failed': props<CreateCategoryResponse>(),

    'Update catetogy event': props<{ payload: UpdateCategorieEventRequest, eventId: string, categoryId: string }>(),
    'Update catetogy event success': props<UpdateCategoryResponse>(),
    'Update catetogy event failed': props<UpdateCategoryResponse>(),

    'Import catetogies event': props<{ payload: ImportFileEventCategoriesRequest, eventId: string }>(),
    'Import catetogies event success': props<ImportCategoriesResponse>(),
    'Import catetogies event failed': props<ImportCategoriesResponse>(),

    'Delete catetogy event': props<{ payload: DeleteCategorieEventRequest, eventId: string, categoryId: string }>(),
    'Delete catetogy event success': props<DeleteCategoryResponse>(),
    'Delete catetogy event failed': props<{ error: any }>(),

    'Reset categories event': emptyProps()

  }
});
